var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.79 3.537c.861.227 1.533.89 1.766 1.738.61 2.418.57 6.99.013 9.445a2.483 2.483 0 0 1-1.767 1.738c-2.432.592-13.326.519-15.618 0A2.483 2.483 0 0 1 .418 14.72c-.575-2.305-.535-7.178-.013-9.432A2.483 2.483 0 0 1 2.172 3.55c3.251-.668 14.46-.452 15.618-.013zM8.06 7.051l5.223 2.947-5.223 2.947V7.05z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.7b24d4124e9043e652655b0afa7f1098.svg";
export { ForwardRef as ReactComponent };